import React, { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { WaterIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { useStyles } from "../../useStyles";
import { InputLabel } from "@material-ui/core";
import { NumberInput } from "../core/NumberField";

export const IncreaseExpectedElectricBoilerForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_ELECTRIC_BOILER>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<WaterIcon />}
                content={
                    <p className={classes.label}>
                        Elektrische Warmwasseraufbereitung (Durchlauferhitzer)
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedElectricBoiler.value.installed}
                        {...getFieldProps("adjustableLoadElectricBoiler.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedElectricBoiler.value.installed = checked;
                                values.increaseExpectedElectricBoiler.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedElectricBoiler.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.increaseExpectedElectricBoiler.value.demand.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseExpectedElectricBoiler.value.demand.unit}
                            value={values.increaseExpectedElectricBoiler.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseExpectedElectricBoiler.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseExpectedElectricBoiler.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
